export default __webpack_public_path__ + "2452f114322993b0e4da82f74dcb7f57.png";